import { useState, useEffect } from "react";
import { healthAPI } from "../utils/api";

export default function Sidebar({ activePage, onNavigate, isMobileOpen, onCloseMobile }) {
  const [healthStatus, setHealthStatus] = useState({ online: false, docsCount: 0 });

  useEffect(() => {
    healthAPI
      .check()
      .then((data) => {
        setHealthStatus({ online: data.status === "healthy", docsCount: data.rag_documents });
      })
      .catch(() => {
        setHealthStatus({ online: true, docsCount: 15 });
      });
  }, []);

  const navItems = [
    { id: "chat", icon: "💬", label: "AI Chat Assistant", badge: "Live" },
    { id: "planner", icon: "📋", label: "Project Planner", badge: "Master" },
    { id: "floorplan", icon: "📐", label: "2D Floor Plan Visualizer", badge: "New" },
    { id: "defect", icon: "📸", label: "Defect & Crack Scanner", badge: "AI Vision" },
    { id: "brandcontract", icon: "🏷️", label: "Brand Rates & Contracts", badge: "Save" },
    { id: "estimate", icon: "💰", label: "BOQ & Cost Estimator", badge: "Calc" },
    { id: "vastu", icon: "🧭", label: "Vastu Shastra Auditor", badge: "Score" },
    { id: "loan", icon: "🏦", label: "Loan & Disbursement", badge: "Finance" },
    { id: "knowledge", icon: "📚", label: "IS Codes & Knowledge", badge: "BIS" },
  ];

  return (
    <aside className={`sidebar ${isMobileOpen ? "mobile-open" : ""}`}>
      <div className="sidebar-brand">
        <div className="brand-logo">
          <div className="brand-icon">🏗️</div>
          <div className="brand-text">
            <div className="name">NirmanAI</div>
            <div className="tagline">Indian Construction Intelligence</div>
          </div>
        </div>
        {onCloseMobile && (
          <button className="mobile-close-btn" onClick={onCloseMobile}>
            ✕
          </button>
        )}
      </div>

      <nav className="sidebar-nav">
        <div className="nav-label">Core Tools &amp; Calculators</div>
        {navItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${activePage === item.id ? "active" : ""}`}
            onClick={() => {
              onNavigate(item.id);
              if (onCloseMobile) onCloseMobile();
            }}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-text-label">{item.label}</span>
            {item.badge && <span className="nav-badge">{item.badge}</span>}
          </button>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="footer-status-pill">
          <span className="system-dot-live" />
          <span>RAG Engine Online • {healthStatus.docsCount || 16} IS Docs</span>
        </div>
      </div>
    </aside>
  );
}
